/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ErrorPayload } from '../../../../interfaces/auth/IErrorPayload';
import {
    useAuthWithAgentMutation,
    useSignInWithAgentMutation
} from '../../../../store/auth/authApi';
import ChatHeader from '../../../../shared/chat-header';
import ChatInput from '../../../../shared/chat-bar';



const SWITCH_USER_FLAG = 'switchUser';
const USED_IT_MESSAGE = 'used it';

const LoginUserForm = () => {
    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const hasAutoSentRef = useRef(false);
    const [authWithAgent, { error }] = useAuthWithAgentMutation();
    const [signInAgent] = useSignInWithAgentMutation()
    const [chatData, setChatData] = useState<any>([]);
    const [errorAuthorize, setErrorAuthorize] = useState<string>()
    const getAuthMessages = () => authWithAgent({ linkToken: id || '', chatData: [], dashboard: 'charles' }).unwrap();
    const getAuthSignInMessages = () => signInAgent({ chatData: [], dashboard: 'charles' }).unwrap();
    const { authMessages, topicId } = useSelector((state: any) => state.chats);

    useEffect(() => {
        if (authMessages.find((message: any) => message.agent?.stage === 'authenticated') || localStorage.getItem('accessToken')) {
            setTimeout(() => {
                navigate('/insights')
            }, 500)
        }
    }, [authMessages]);

    useEffect(() => {
        try {
            if (id) {
                getAuthMessages()
            } else {
                getAuthSignInMessages()
            }
        } catch (err) {
            console.error(err)
        }
    }, [id]);

    useEffect(() => {
        setChatData(authMessages)
    }, [authMessages])

    useEffect(() => {
        const isSwitchUser = searchParams.get(SWITCH_USER_FLAG) === 'true';
        const lastMessage = authMessages[authMessages.length - 1];
        const lastIsFromAgent = lastMessage?.agent?.message;
        const shouldAutoSend = isSwitchUser && !id && authMessages.length > 0 && lastIsFromAgent && !hasAutoSentRef.current;

        if (shouldAutoSend) {
            hasAutoSentRef.current = true;
            searchParams.delete(SWITCH_USER_FLAG);
            setSearchParams(searchParams, { replace: true });
            const chatDataWithUsedIt = [
                ...authMessages,
                { user: { message: USED_IT_MESSAGE } }
            ];
            onGettingChatData(chatDataWithUsedIt);
        }
    }, [authMessages, id, searchParams, setSearchParams])

    let errorMsg: any

    const onGettingChatData = async (newChatData?: any) => {
        try {
            const { stage, sort, flow } = authMessages[authMessages.length - 1]?.agent || {};
            if (id) {
                await authWithAgent(
                    {
                        chatId: topicId,
                        linkToken: id || '',
                        dashboard: 'charles',
                        chatData: [
                            ...authMessages,
                            {
                                user: {
                                    message: newChatData?.[newChatData?.length - 1]?.user?.message,
                                    stage,
                                    sort: sort + 1,
                                    flow
                                }
                            }
                        ]
                    }).unwrap();
            } else {
                await signInAgent(
                    {
                        dashboard: 'charles',
                        chatId: topicId,
                        chatData: [
                            ...authMessages,
                            {
                                user: {
                                    message: newChatData?.[newChatData?.length - 1]?.user?.message,
                                    stage,
                                    sort: sort + 1,
                                    flow
                                }
                            }
                        ]
                    }).unwrap();
            }
        } catch (error) {
            const err = error as { name: string }
            if (err?.name === 'AbortError') {
                console.error('Request was cancelled.');
            } else {
                console.error({ err })
            }
        } finally {
            // setTimeout(() => {
            //     contentEditableRef.current?.focus();
            // }, 100);
        }
    }

    const err = { ...error as ErrorPayload };
    errorMsg = err.status === 401 ? 'Username or password are incorrect' : 'Something went wrong'
    return (
        <div className='!rounded-xl bg-[#f5f5f5] p-0'>
            <ChatHeader />
            <div className='p-3'>
                {(!!err.data || errorAuthorize) && <div className='p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800' role='alert'>
                    <span className='font-medium'> {errorAuthorize || err.data.message || errorMsg} </span>
                </div>}
                <ChatInput
                    chatData={chatData || authMessages}
                    onGettingChatData={onGettingChatData}
                />
            </div>
        </div>
    )
}

export default LoginUserForm;